import { Component, OnInit, Input, ViewEncapsulation, ViewContainerRef } from '@angular/core';

import { Router } from '@angular/router';

import { User } from '../_models/User';
import { Engine } from '../_models/Engine';
import { Organization } from '../_models/Organization';

import { UserService } from '../_services/user.service';
import { OrganizationService } from '../_services/organization.service';
import { DialogService } from '../_services/dialog.service';
import { getUrl } from '../_shared/utils';
import { UserActionsModalComponent } from './user-actions-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from '../_services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class UserManagementComponent implements OnInit {

  // Environment Variables
  baseUrl = getUrl();

  public users: User[] = [];
  public filteredUsers: User[] = [];
  public displayUsers: User[] = [];
  public displayInactive = false;

  public organizations: Organization[] = [];
  public selectedOrganization: Organization;

  public engines: Engine[] = [];
  public selectedEngine: Engine;

  reorderable = true;
  searchText: any;

  public loading = false;
  public hasSiteManagement = false;
  public reportActivity = true;

  private bsModalRef: BsModalRef;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private organizationService: OrganizationService,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.userService.hasSinglePermission('SiteManagement').subscribe(data => {
      this.hasSiteManagement = data;
    });
    this.userService.hasSinglePermission('ReportActivity').subscribe(data => {
      this.reportActivity = data;
    });
    this.getUsers();
    this.getOrganizations();
    this.getEngines();
  }

  filterUsers() {
    let temp: User[] = this.users;
    if (this.displayInactive) {
      temp = this.users;
    } else {
      temp = this.filteredUsers;
    }

    if (this.selectedOrganization != null) {
      temp = temp.filter(u => u.organization.name === this.selectedOrganization.name);
    }

    if (this.selectedEngine != null) {
      temp = temp.filter(u => u.engine.applicationName === this.selectedEngine.applicationName);
    }

    this.displayUsers = temp;
  }

  private getEngines() {
    this.userService.getUserEngines().subscribe(data => {
      this.engines = data;
    });
  }

  private getUsers() {
    this.loading = true;
    this.spinner.show();
    this.userService.getAllUsers().subscribe(data => {
      this.users = data;
      this.filteredUsers = this.users.filter(u => u.active === true);
      this.displayUsers = this.filteredUsers;
      this.loading = false;
      this.spinner.hide();
    }, error => {
      alert(error.message);
      this.loading = false;
      this.spinner.hide();
    });
  }

  private getOrganizations() {
    this.loading = true;
    this.spinner.show();
    this.organizationService.getAllOrganizations().subscribe(data => {
      this.organizations = data;
    }, error => {
      alert(error.message);
      this.loading = false;
      this.spinner.hide();
    });
  }

  public exportUserData() {
    this.loading = true;
    this.spinner.show();
    
    this.userService.exportUserData().subscribe(() => {
      this.loading = false;
      this.spinner.hide();
      this.dialogService.alert('User Data Exported', 'Report sent to ' + this.authService.getUserEmail(), this.viewRef);
    });
  }

  public addUser() {
    this.router.navigate(['/portal/users/create']);
  }

  public search() {
    if (!this.searchText) {
      return;
    }
    const search = this.searchText.toLowerCase();
    const tempUsers = this.users.filter(function (d) {
      return d.email.toLowerCase().indexOf(search) !== -1 || !search;
    });
    this.displayUsers = tempUsers;
  }

  public deleteUser(userId: number) {
    this.dialogService.confirm(
      'Remove User',
      'Are you sure you want to delete this user?',
      this.viewRef).then((result) => {
        if (result === true) {
          this.userService.deleteUser(userId).subscribe(data => {
            this.getUsers();
          }, error => {
            alert(error.message);
          });
        }
      });
  }

  public enableUser(userId: number) {
    this.dialogService.confirm(
      'Enable User',
      'Are you sure you want enable this inactive user?',
      this.viewRef).then((result) => {
        if (result === true) {
          this.userService.enableUser(userId).subscribe(data => {
            this.getUsers();
          }, error => {
            alert(error.message);
          });
        }
      });
  }

  public editUser(userId: any) {
    this.router.navigate(['/portal/users', userId]);
  }

  public openMoreActions(user: User) {
    const modalConfig = {
      backdrop: true,
      ignoreBackdropClick: true
    };

    const initialState = {
      user: user,
    };

    this.bsModalRef = this.modalService
      .show(
        UserActionsModalComponent, 
        Object.assign({}, modalConfig, { class: 'modal-sm', initialState }));
  }



}
